import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import iziToast from 'izitoast';
import Swal from 'sweetalert2';
import { ServiceService } from '../services/service.service';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.css']
})
export class PaymentSuccessComponent implements OnInit {

  planName: any;
  planPrice: any;
  moblieNumber: any;

  constructor(private router: Router, private serviceservice: ServiceService, private location: Location, private route: ActivatedRoute) { }


  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.moblieNumber = params['current_user_id'];
      this.planName = params['current_plan_name'];
      this.planPrice = params['current_plan_price'];

      //console.log(this.planName, this.planPrice);
    });
  }

  showSuccess = true;

  payment = {
    paymentType: 'Net banking',
    bank: 'HDFC',
    mobile: '8897131444',
    plan: 'CL 499_50mbps',
    email: 'test@gmail.com',
    amount: 500.00,
    transactionId: '125478965698'
  };

  printReceipt() {
    this.router.navigate(['/users-dashboard']);
  }

  closePopup() {
    this.showSuccess = false;
  }

}
